import { adminHttp } from "@shared/lib/http";
import { isStubEnabled } from "@sdk/core";

export type StoreSummary = {
  id: string;
  name: string;
  slug: string;
  tenantId: string;
  planId?: string | null;
  subscriptionStatus?: string | null;
  status?: string | null;
  isPrimary?: boolean;
  domain?: string | null;
};

// Stub data for offline/demo mode
const STUB_STORES: StoreSummary[] = [
  {
    id: "stub-store-1",
    name: "Demo Store",
    slug: "demo",
    tenantId: "demo-tenant",
    isPrimary: true,
  },
];

export async function listStores(): Promise<StoreSummary[]> {
  if (isStubEnabled()) return STUB_STORES;

  try {
    const res = await adminHttp.get("/api/stores");
    return Array.isArray(res) ? (res as unknown as StoreSummary[]) : [];
  } catch {
    return [];
  }
}
